/**
 * Custom-domain `/profile` -> `/me`.
 *
 * `/me` is the single canonical member-profile URL: member navigation, the
 * account menu and existing bookmarks all point there, and it is the only
 * member-profile route registered in all three route trees. The custom-domain
 * tree additionally carried a SECOND member-profile implementation at
 * `/profile`, which had drifted from `/me` (a giving source with no merge gate,
 * different household precedence, and cards bound to payload fields the server
 * never returns). Rather than maintain two member profiles, that path redirects.
 *
 * SCOPE: this redirect belongs ONLY to the custom-domain route tree. In the
 * `/o/:orgSlug` and `/:orgSlug` trees, `profile` is the ORGANIZATION's public
 * profile page (OrgPublicProfile) and must keep serving it — those routes are
 * deliberately untouched.
 *
 * Search and hash are preserved so a deep link such as `/profile#household`
 * still lands on the right section of `/me`.
 */
import React from "react";
import { Navigate, useLocation } from "react-router-dom";

export default function CustomDomainMemberProfileRedirect() {
  const location = useLocation();
  const destination = `/me${location.search || ""}${location.hash || ""}`;
  return <Navigate to={destination} replace />;
}
